<template>
  <div>
     <b-button
      v-permission="'group_news.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      ref="grid"
      :service="service"
      route_name="group-news"
      :route_grid_path="`/grid`"
      order_column="name"
      >
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('group_news.name') }}</vs-th>
        <vs-th key="description" sort-key="description">{{ $t('group_news.description') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="30%" key="name">
            <div> {{ tr.name }}</div>
          </vs-td>
          <vs-td width="40%" key="description">
            <div v-html-safe="tr.description"></div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'group_news.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'group_news.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>

                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <feather-icon
                    type="filled"
                    icon="MoreVerticalIcon"
                    class="h-5 w-5 mb-1 mr-1 stroke-current">
                  </feather-icon>
                  <vs-dropdown-menu>
                      <vs-dropdown-item>
                        <div
                          class="flex"
                          style="width: 150px;" @click="confirmCloneByGroup(props.data[indextr])">
                          <div class="w-2/12">
                            <feather-icon
                                icon="GridIcon"
                                svgClasses="h-5 w-5 mb-1 stroke-current text-primary"/>
                          </div>

                          <div class="w-10/12">
                            <div class="flex bg-gray-200 float-left">
                              {{ $t('action.clone_newsletter_by_group') }}
                            </div>
                          </div>
                        </div>
                      </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'


import GroupNewsService from '@/services/api/GroupNewsService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/group-news/create')
    },
    reloadGrid(){
      this.$refs.grid.fetchGridData()
    },
    confirmCloneByGroup(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja clonar TODOS os informativos do grupo: ' + _.get(item, 'name') + '?',
        accept: () => {
          this.cloneByGroup(item)
        }
      })
    },
    cloneByGroup(item) {
      const groupId = _.get(item, 'id')
      if(!groupId){
        this.notifyWarning(this.$vs, 'Não é possível clonar por grupo.', 5000, 'center-top')
        return
      }

      this.$vs.loading()
      this.service.cloneByGroup(item.id).then(
        response => {
          this.notifySuccess(this.$vs, 'Informativo clonado com sucesso para o grupo: ' + _.get(item, 'name') + '!', 3000, 'center-top')
          this.reloadGrid()
        })
        .catch(error => {
          this.notifyError(this.$vs, 'Erro ao clonar informativo.', 5000, 'center-top')
        })
        .finally(() => this.$vs.loading.close())
    },
  },
  beforeMount() {
    this.service = GroupNewsService.build(this.$vs)
  }
}
</script>
